import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const WeekdayHeader = ({
    sx = {},
    ...props
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const dayNames = [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')];

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                padding: '0 20px',
                width: '100%',
                ...sx,
            }}
            {...props}
        >
            {dayNames.map((dayName, index) => (
                <Box
                    key={dayName}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        borderRadius: '15px',
                        boxShadow: index === 3 ? (theme.palette.shadows?.elevation?.[2] ?? 'none') : 'none', // 수요일에 그림자
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '12px',
                            color: theme.palette.figma.white[60],
                            fontWeight: 400,
                            letterSpacing: '-0.36px',
                            textAlign: 'center',
                            width: '100%',
                        }}
                    >
                        {dayName}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default WeekdayHeader;